import { ref, Ref } from "vue";

interface ToggleUtils {
  state: Ref<boolean>;
  toggle(): void;
}

export default function useToggle(initValue: boolean | Ref<boolean>): ToggleUtils {
  const state = ref(initValue);
  const toggle = () => {
    state.value = !state.value;
  };

  return {
    state,
    toggle,
  };
}
